import { campaignReportsActions } from 'store/actions';
import store from 'store';

export function getQueryString(requestType, timePeriod, id) {
  return (
    requestType +
    '&from=' +
    formatTimePeriodForRequest(timePeriod.from) +
    '&to=' +
    formatTimePeriodForRequest(timePeriod.to) +
    '&campaignId=' +
    id
  );
}

function formatTimePeriodForRequest(date) {
  return date.split('/').reverse().join('-');
}

export const cleanSelectedTableItems = () => {
  const dispatch = store.dispatch;
  dispatch(
    campaignReportsActions.updateProperty({
      propField: 'selectedTableItems',
      newValue: [],
    }),
  );
};
